export default {
	MERCHANDISE: 'companies/:company_id/merchandise/',
	MERCHANDISE_DISCOUNT: 'companies/:company_id/merchandise-discount/',
	PRODUCT_CATEGORIES: 'companies/:company_id/product-categories/',
}